import { Injectable }                      from '@angular/core';
import { ModalDismissReasons, NgbModal }   from '@ng-bootstrap/ng-bootstrap';

import { VehicleVisualsPlayerComponent } from './vehicle-visuals.player.component';

@Injectable({
  providedIn: 'root'
})
export class VehicleVisualsService {
  constructor (
    private modalService: NgbModal
  ) {}

  play ( url : string, title? : string ) : Promise<any> {
    const playUrl  = this.withAutoPlay(url);
    const modalRef = this.modalService.open(VehicleVisualsPlayerComponent, {
      windowClass: this.modalWindowClass()
    });

    modalRef.componentInstance.title = title;
    modalRef.componentInstance.url   = playUrl;

    return modalRef.result.catch(( reason : any ) => {
      if (this.isDismiss(reason)) {
        return null;
      }

      return Promise.reject(reason);
    });
  }

  /**
   * Inspection-bundle customers see attachments from a short-URL vendor share
   * page whose chrome dwarfs the player at our default modal size. Render the
   * modal full-screen on that bundle so the player fills the viewport.
   */
  private modalWindowClass () : string {
    const base = 'vehicle-visuals-player-modal';

    return window.location.pathname.includes('inspection.html')
      ? `${ base } vehicle-visuals-player-modal-fullscreen`
      : base;
  }

  /**
   * WS-6645. The replace alone only ever rewrites a parameter that is already present, and
   * nothing in either repository adds one: every Vehicle Visuals URL stored in production
   * carries a query string and none contains auto_play, so the animation never auto started
   * for any workshop. WS-6323 built that behaviour and WS-6486 reverted the append to stop
   * a bare short URL such as srvc.video/aZk2q being turned into an invalid address.
   *
   * Appending only when the URL already has a query string delivers WS-6323 without
   * recreating that regression, because a bare short URL has no question mark and is
   * returned untouched.
   */
  private withAutoPlay ( url : string ) : string {
    if (/auto_play=\d+/.test(url)) {
      return url.replace(/auto_play=\d+/, 'auto_play=1');
    }

    return url.includes('?') ? `${ url }&auto_play=1` : url;
  }

  private isDismiss ( reason : any ) : boolean {
    return reason === undefined
      || reason === ModalDismissReasons.BACKDROP_CLICK
      || reason === ModalDismissReasons.ESC;
  }
}
